/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".green-background[_ngcontent-%COMP%]{background-color:#a0c13a!important}"];
export { styles as styles };
//# sourceMappingURL=speechace-tile.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/speechace-tile/speechace-tile.component.scss.shim.ngstyle.js
// module id = 1649
// module chunks = 27 28 29